export default {
  data: () => ({
    twocheckoutStyles: {
      margin: 0,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Open Sans", "Roboto", "Helvetica Neue", "Ubuntu", sans-serif',
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '16px',
      color: '#525F7F',
      textAlign: 'left',
      backgroundColor: '#FFFFFF',
      '*': {
        boxSizing: 'border-box'
      },
      '.no-gutters': {
        marginRight: 0,
        marginLeft: 0
      },
      '.row': {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '3px'
      },
      '.col': {
        flexBasis: '0',
        flexGrow: '1',
        maxWidth: '100%',
        padding: '0',
        position: 'relative',
        width: '100%'
      },
      div: {
        display: 'block'
      },
      '.field-container': {
        paddingBottom: '14px'
      },
      '.input-wrapper': {
        position: 'relative'
      },
      label: {
        display: 'inline-block',
        marginBottom: '3px',
        color: '#6B8699',
        fontSize: '0.875rem',
        fontWeight: '400',
        lineHeight: '1.375rem'
      },
      input: {
        overflow: 'visible',
        margin: 0,
        fontFamily: 'inherit',
        display: 'block',
        width: '100%',
        height: '40px',
        padding: '6px 12px',
        fontSize: '13px',
        fontWeight: '400',
        lineHeight: '18px',
        color: '#6B8699',
        backgroundColor: '#FFFFFF',
        backgroundClip: 'padding-box',
        border: '1px solid #D6D9E2',
        borderRadius: '6px',
        outline: 0
      },
      'input:focus': {
        border: '1px solid #4051B5',
        boxShadow: '0px 0px 0px 3px #CCE1FF'
      },
      '.is-error input': {
        color: '#F57F6C',
        border: '1px solid #FF5252'
      },
      '.is-error input:focus': {
        color: '#F57F6C',
        border: '1px solid #FF5252',
        boxShadow: '0px 0px 0px 3px #FFCDD2'
      },
      '.validation-message': {
        color: '#F57F6C',
        fontSize: '12px',
        marginTop: '10px',
        marginBottom: '-5px',
        display: 'block',
        lineHeight: '1'
      },
      '.card-expiration-date': {
        paddingRight: '.5rem'
      },
      '.is-empty input': {
        color: '#EBEBEB'
      },
      '.lock-icon': {
        top: 'calc(50% - 7px)',
        right: '10px'
      },
      '.valid-icon': {
        top: 'calc(50% - 8px)',
        right: '-25px'
      },
      '.error-icon': {
        top: 'calc(50% - 8px)',
        right: '-25px'
      },
      '.card-icon': {
        top: 'calc(50% - 10px)',
        left: '10px',
        display: 'none'
      },
      '.is-empty .card-icon': {
        display: 'block'
      },
      '.is-focused .card-icon': {
        display: 'none'
      },
      '.card-type-icon': {
        right: '30px',
        display: 'block'
      },
      '.card-type-icon.visa': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.mastercard': {
        top: 'calc(50% - 14.5px)'
      },
      '.card-type-icon.amex': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.discover': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.jcb': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.dankort': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.cartebleue': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.diners': {
        top: 'calc(50% - 14px)'
      },
      '.card-type-icon.elo': {
        top: 'calc(50% - 14px)'
      }
    }
  })
}